// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__cVOu6","onlineTag":"Tags_onlineTag__3nyUw","tag":"Tags_tag__32D9o"};